/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-Dm1irIE2.js";
import { t } from "./decorateMetadata-BhwOl-pv.js";
import { t as n } from "./decorate-DHgd5sZx.js";
import { FormElement as r } from "./elements/formElement.js";
import "./checkbox-BOki-Nk5.js";
import "./elements/form-elements/text-input.js";
import { LitElement as i, html as a, nothing as o } from "lit";
import { customElement as s, property as c, state as l } from "lit/decorators.js";
//#region ../../node_modules/.pnpm/ibantools@4.5.4/node_modules/ibantools/jsnext/ibantools.js
function u(e, t = { allowQRIBAN: !0 }) {
	if (e == null) return !1;
	let n = /* @__PURE__ */ RegExp("^[0-9]{2}$", ""), r = e.slice(0, 2), i = A[r];
	return i === void 0 || i.bban_regexp === void 0 || i.bban_regexp === null || i.chars === void 0 ? !1 : i.chars === e.length && n.test(e.slice(2, 4)) && f(e.slice(4), r) && g(e) && (t.allowQRIBAN || !p(e));
}
var d;
(function(e) {
	e[e.NoIBANProvided = 0] = "NoIBANProvided", e[e.NoIBANCountry = 1] = "NoIBANCountry", e[e.WrongBBANLength = 2] = "WrongBBANLength", e[e.WrongBBANFormat = 3] = "WrongBBANFormat", e[e.ChecksumNotNumber = 4] = "ChecksumNotNumber", e[e.WrongIBANChecksum = 5] = "WrongIBANChecksum", e[e.WrongAccountBankBranchChecksum = 6] = "WrongAccountBankBranchChecksum", e[e.QRIBANNotAllowed = 7] = "QRIBANNotAllowed";
})(d ||= {});
function f(e, t) {
	if (e == null || t == null) return !1;
	let n = A[t];
	return n == null || n.bban_regexp === void 0 || n.bban_regexp === null || n.chars === void 0 || n.chars === null ? !1 : n.chars - 4 === e.length && m(e, n.bban_regexp) ? !n.bban_validation_func || n.bban_validation_func(e.replace(/[\s.]+/g, "")) : !1;
}
function p(e) {
	if (e == null) return !1;
	let t = e.slice(0, 2);
	return ["LI", "CH"].includes(t) ? (/* @__PURE__ */ RegExp("^3[0-1]{1}[0-9]{3}$", "")).test(e.slice(4, 9)) : !1;
}
function m(e, t) {
	return new RegExp(t, "").test(e);
}
function h(e) {
	return typeof e == "string" ? e.replace(/[-\ ]/g, "").toUpperCase() : null;
}
function g(e) {
	let t = e.slice(0, 2), n = parseInt(e.slice(2, 4), 10);
	return 98 - x(_(`${e.slice(4)}${t}00`)) === n;
}
function _(e) {
	return e.split("").map((e) => {
		let t = e.charCodeAt(0);
		return t >= 65 ? (t - 55).toString() : e;
	}).join("");
}
var v;
(function(e) {
	e[e.NoBICProvided = 0] = "NoBICProvided", e[e.NoBICCountry = 1] = "NoBICCountry", e[e.WrongBICFormat = 2] = "WrongBICFormat";
})(v ||= {});
var y = (e) => {
	let t = [
		5,
		4,
		3,
		2,
		7,
		6,
		5,
		4,
		3,
		2
	], n = e.replace(/[\s.]+/g, ""), r = parseInt(n.charAt(10), 10), i = n.substring(0, 10), a = 0;
	for (let e = 0; e < 10; e++) a += parseInt(i.charAt(e), 10) * t[e];
	let o = a % 11;
	return r === (o === 0 ? 0 : 11 - o);
}, b = (e) => {
	let t = e.replace(/[\s.]+/g, ""), n = parseInt(t.substring(0, t.length - 2), 10), r = parseInt(t.substring(t.length - 2, t.length), 10);
	return (n % 97 == 0 ? 97 : n % 97) === r;
}, x = (e) => {
	for (; e.length > 2;) {
		let t = e.slice(0, 6), n = parseInt(t, 10);
		if (isNaN(n)) return NaN;
		e = n % 97 + e.slice(t.length);
	}
	return parseInt(e, 10) % 97;
}, S = (e) => x(e.replace(/[\s.]+/g, "")) === 1, C = (e) => {
	let t = [
		3,
		9,
		7,
		1,
		3,
		9,
		7
	], n = parseInt(e.charAt(7), 10), r = e.substring(0, 7), i = 0;
	for (let e = 0; e < 7; e++) i += parseInt(r.charAt(e), 10) * t[e];
	let a = i % 10;
	return n === (a === 0 ? 0 : 10 - a);
}, w = (e) => {
	let t = [
		4,
		8,
		5,
		10,
		9,
		7,
		3,
		6
	], n = [
		1,
		2,
		4,
		8,
		5,
		10,
		9,
		7,
		3,
		6
	], r = parseInt(e.charAt(8), 10), i = parseInt(e.charAt(9), 10), a = e.substring(0, 8), o = e.substring(10, 20), s = 0;
	for (let e = 0; e < 8; e++) s += parseInt(a.charAt(e), 10) * t[e];
	let c = s % 11;
	if (r !== (c === 0 ? 0 : c === 1 ? 1 : 11 - c)) return !1;
	s = 0;
	for (let e = 0; e < 10; e++) s += parseInt(o.charAt(e), 10) * n[e];
	return c = s % 11, i === (c === 0 ? 0 : c === 1 ? 1 : 11 - c);
}, T = (e, t) => {
	let n = 10;
	for (let t = 0; t < e.length; t++) n += parseInt(e.charAt(t), 10), n % 10 != 0 && (n %= 10), n *= 2, n %= 11;
	return t === (11 - n == 10 ? 0 : 11 - n);
}, E = (e) => {
	let t = parseInt(e.charAt(6), 10), n = parseInt(e.charAt(16), 10), r = e.substring(0, 6), i = e.substring(7, 16);
	return T(r, t) && T(i, n);
}, D = (e) => {
	let t = [
		10,
		5,
		8,
		4,
		2,
		1
	], n = [
		6,
		3,
		7,
		9,
		10,
		5,
		8,
		4,
		2,
		1
	], r = parseInt(e.charAt(9), 10), i = parseInt(e.charAt(19), 10), a = e.substring(4, 9), o = e.substring(10, 19), s = 0;
	for (let e = 0; e < a.length; e++) s += parseInt(a.charAt(e), 10) * t[e];
	let c = s % 11;
	if (r !== (c === 0 ? 0 : c === 1 ? 1 : 11 - c)) return !1;
	s = 0;
	for (let e = 0; e < o.length; e++) s += parseInt(o.charAt(e), 10) * n[e];
	return c = s % 11, i === (c === 0 ? 0 : c === 1 ? 1 : 11 - c);
}, O = (e) => {
	let t = [
		7,
		1,
		3,
		7,
		1,
		3,
		7,
		1,
		3,
		7,
		1,
		3,
		7
	], n = parseInt(e.charAt(15), 10), r = e.substring(2, 15), i = 0;
	for (let e = 0; e < r.length; e++) i += parseInt(r.charAt(e), 10) * t[e];
	let a = i % 10;
	return n === (a === 0 ? 0 : 10 - a);
}, k = (e) => {
	let t = e.replace(/[\s.]+/g, ""), n = Array.from(t);
	for (let e = 0; e < t.length; e++) {
		let t = n[e].charCodeAt(0);
		if (t >= 65) switch (t) {
			case 65:
			case 74:
				n[e] = "1";
				break;
			case 66:
			case 75:
			case 83:
				n[e] = "2";
				break;
			case 67:
			case 76:
			case 84:
				n[e] = "3";
				break;
			case 68:
			case 77:
			case 85:
				n[e] = "4";
				break;
			case 69:
			case 78:
			case 86:
				n[e] = "5";
				break;
			case 70:
			case 79:
			case 87:
				n[e] = "6";
				break;
			case 71:
			case 80:
			case 88:
				n[e] = "7";
				break;
			case 72:
			case 81:
			case 89:
				n[e] = "8";
				break;
			case 73:
			case 82:
			case 90: n[e] = "9";
		}
	}
	return x(n.join("")) === 0;
}, A = {
	AD: {
		chars: 24,
		bban_regexp: "^[0-9]{8}[A-Z0-9]{12}$",
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "4-7",
		bank_identifier: "0-3",
		account_indentifier: "12-23"
	},
	AE: {
		chars: 23,
		bban_regexp: "^[0-9]{3}[0-9]{16}$",
		IBANRegistry: !0,
		bank_identifier: "0-2",
		account_indentifier: "7-23"
	},
	AF: {},
	AG: {},
	AI: {},
	AL: {
		chars: 28,
		bban_regexp: "^[0-9]{8}[A-Z0-9]{16}$",
		IBANRegistry: !0,
		branch_indentifier: "3-7",
		bank_identifier: "0-2",
		account_indentifier: "12-28"
	},
	AM: {},
	AO: {
		chars: 25,
		bban_regexp: "^[0-9]{21}$"
	},
	AQ: {},
	AR: {},
	AS: {},
	AT: {
		chars: 20,
		bban_regexp: "^[0-9]{16}$",
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-4"
	},
	AU: {},
	AW: {},
	AX: {
		chars: 18,
		bban_regexp: "^[0-9]{14}$",
		IBANRegistry: !0
	},
	AZ: {
		chars: 28,
		bban_regexp: "^[A-Z]{4}[A-Z0-9]{20}$",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		account_indentifier: "4-28"
	},
	BA: {
		chars: 20,
		bban_regexp: "^[0-9]{16}$",
		bban_validation_func: S,
		IBANRegistry: !0,
		branch_indentifier: "3-5",
		bank_identifier: "0-2"
	},
	BB: {},
	BD: {},
	BE: {
		chars: 16,
		bban_regexp: "^[0-9]{12}$",
		bban_validation_func: b,
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-2",
		account_indentifier: "0-16"
	},
	BF: {
		chars: 28,
		bban_regexp: "^[A-Z0-9]{2}[0-9]{22}$"
	},
	BG: {
		chars: 22,
		bban_regexp: "^[A-Z]{4}[0-9]{6}[A-Z0-9]{8}$",
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "4-7",
		bank_identifier: "0-3"
	},
	BH: {
		chars: 22,
		bban_regexp: "^[A-Z]{4}[A-Z0-9]{14}$",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		account_indentifier: "8-22"
	},
	BI: {
		chars: 27,
		bban_regexp: "^[0-9]{23}$",
		branch_indentifier: "5-9",
		bank_identifier: "0-4",
		account_indentifier: "14-27"
	},
	BJ: {
		chars: 28,
		bban_regexp: "^[A-Z0-9]{2}[0-9]{22}$"
	},
	BL: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$"
	},
	BM: {},
	BN: {},
	BO: {},
	BQ: {},
	BR: {
		chars: 29,
		bban_regexp: "^[0-9]{23}[A-Z]{1}[A-Z0-9]{1}$",
		IBANRegistry: !0,
		branch_indentifier: "8-12",
		bank_identifier: "0-7",
		account_indentifier: "17-29"
	},
	BS: {},
	BT: {},
	BV: {},
	BW: {},
	BY: {
		chars: 28,
		bban_regexp: "^[A-Z]{4}[0-9]{4}[A-Z0-9]{16}$",
		IBANRegistry: !0,
		bank_identifier: "0-3"
	},
	BZ: {},
	CA: {},
	CC: {},
	CD: {},
	CF: {
		chars: 27,
		bban_regexp: "^[0-9]{23}$"
	},
	CG: {
		chars: 27,
		bban_regexp: "^[0-9]{23}$"
	},
	CH: {
		chars: 21,
		bban_regexp: "^[0-9]{5}[A-Z0-9]{12}$",
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-4"
	},
	CI: {
		chars: 28,
		bban_regexp: "^[A-Z]{1}[0-9]{23}$"
	},
	CK: {},
	CL: {},
	CM: {
		chars: 27,
		bban_regexp: "^[0-9]{23}$"
	},
	CN: {},
	CO: {},
	CR: {
		chars: 22,
		bban_regexp: "^[0-9]{18}$",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		account_indentifier: "8-22"
	},
	CU: {},
	CV: {
		chars: 25,
		bban_regexp: "^[0-9]{21}$"
	},
	CW: {},
	CX: {},
	CY: {
		chars: 28,
		bban_regexp: "^[0-9]{8}[A-Z0-9]{16}$",
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "3-7",
		bank_identifier: "0-2",
		account_indentifier: "12-28"
	},
	CZ: {
		chars: 24,
		bban_regexp: "^[0-9]{20}$",
		bban_validation_func: D,
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-3"
	},
	DE: {
		chars: 22,
		bban_regexp: "^[0-9]{18}$",
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-7",
		account_indentifier: "12-22"
	},
	DJ: {
		chars: 27,
		bban_regexp: "^[0-9]{23}$",
		branch_indentifier: "5-9",
		bank_identifier: "0-4",
		account_indentifier: "14-27"
	},
	DK: {
		chars: 18,
		bban_regexp: "^[0-9]{14}$",
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-3",
		account_indentifier: "4-18"
	},
	DM: {},
	DO: {
		chars: 28,
		bban_regexp: "^[A-Z]{4}[0-9]{20}$",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		account_indentifier: "8-28"
	},
	DZ: {
		chars: 26,
		bban_regexp: "^[0-9]{22}$"
	},
	EC: {},
	EE: {
		chars: 20,
		bban_regexp: "^[0-9]{16}$",
		bban_validation_func: O,
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-1",
		account_indentifier: "8-20"
	},
	EG: {
		chars: 29,
		bban_regexp: "^[0-9]{25}",
		IBANRegistry: !0,
		branch_indentifier: "4-7",
		bank_identifier: "0-3",
		account_indentifier: "17-29"
	},
	EH: {},
	ER: {},
	ES: {
		chars: 24,
		bban_validation_func: w,
		bban_regexp: "^[0-9]{20}$",
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "4-7",
		bank_identifier: "0-3",
		account_indentifier: "14-24"
	},
	ET: {},
	FI: {
		chars: 18,
		bban_regexp: "^[0-9]{14}$",
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-2",
		account_indentifier: "0-0"
	},
	FJ: {},
	FK: {
		chars: 18,
		bban_regexp: "^[A-Z]{2}[0-9]{12}$",
		bank_identifier: "0-1",
		account_indentifier: "6-18"
	},
	FM: {},
	FO: {
		chars: 18,
		bban_regexp: "^[0-9]{14}$",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		account_indentifier: "4-18"
	},
	FR: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
		bban_validation_func: k,
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-4",
		branch_indentifier: "5-9",
		account_indentifier: "14-24"
	},
	GA: {
		chars: 27,
		bban_regexp: "^[0-9]{23}$"
	},
	GB: {
		chars: 22,
		bban_regexp: "^[A-Z]{4}[0-9]{14}$",
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "4-9",
		bank_identifier: "0-3"
	},
	GD: {},
	GE: {
		chars: 22,
		bban_regexp: "^[A-Z0-9]{2}[0-9]{16}$",
		IBANRegistry: !0,
		bank_identifier: "0-1",
		account_indentifier: "6-22"
	},
	GF: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
		IBANRegistry: !0
	},
	GG: {},
	GH: {},
	GI: {
		chars: 23,
		bban_regexp: "^[A-Z]{4}[A-Z0-9]{15}$",
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-3",
		account_indentifier: "8-23"
	},
	GL: {
		chars: 18,
		bban_regexp: "^[0-9]{14}$",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		account_indentifier: "4-18"
	},
	GM: {},
	GN: {},
	GP: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
		IBANRegistry: !0
	},
	GQ: {
		chars: 27,
		bban_regexp: "^[0-9]{23}$"
	},
	GR: {
		chars: 27,
		bban_regexp: "^[0-9]{7}[A-Z0-9]{16}$",
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "3-6",
		bank_identifier: "0-2",
		account_indentifier: "7-27"
	},
	GS: {},
	GT: {
		chars: 28,
		bban_regexp: "^[A-Z0-9]{24}$",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		account_indentifier: "8-28"
	},
	GU: {},
	GW: {
		chars: 25,
		bban_regexp: "^[A-Z]{2}[0-9]{19}$"
	},
	GY: {},
	HK: {},
	HM: {},
	HN: {
		chars: 28,
		bban_regexp: "^[A-Z]{4}[0-9]{20}$"
	},
	HR: {
		chars: 21,
		bban_regexp: "^[0-9]{17}$",
		bban_validation_func: E,
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-6"
	},
	HT: {},
	HU: {
		chars: 28,
		bban_regexp: "^[0-9]{24}$",
		bban_validation_func: (e) => {
			let t = [
				9,
				7,
				3,
				1,
				9,
				7,
				3,
				1,
				9,
				7,
				3,
				1,
				9,
				7,
				3
			], n = parseInt(e.charAt(7), 10), r = e.substring(0, 7), i = 0;
			for (let e = 0; e < r.length; e++) i += parseInt(r.charAt(e), 10) * t[e];
			let a = i % 10;
			if (n !== (a === 0 ? 0 : 10 - a)) return !1;
			if (i = 0, e.endsWith("00000000")) {
				let n = e.substring(8, 15), r = parseInt(e.charAt(15), 10);
				for (let e = 0; e < n.length; e++) i += parseInt(n.charAt(e), 10) * t[e];
				let a = i % 10;
				return r === (a === 0 ? 0 : 10 - a);
			}
			{
				let n = e.substring(8, 23), r = parseInt(e.charAt(23), 10);
				for (let e = 0; e < n.length; e++) i += parseInt(n.charAt(e), 10) * t[e];
				let a = i % 10;
				return r === (a === 0 ? 0 : 10 - a);
			}
		},
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "3-6",
		bank_identifier: "0-2"
	},
	ID: {},
	IE: {
		chars: 22,
		bban_regexp: "^[A-Z0-9]{4}[0-9]{14}$",
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "4-9",
		bank_identifier: "0-3"
	},
	IL: {
		chars: 23,
		bban_regexp: "^[0-9]{19}$",
		IBANRegistry: !0,
		branch_indentifier: "3-5",
		bank_identifier: "0-2"
	},
	IM: {},
	IN: {},
	IO: {},
	IQ: {
		chars: 23,
		bban_regexp: "^[A-Z]{4}[0-9]{15}$",
		IBANRegistry: !0,
		branch_indentifier: "4-6",
		bank_identifier: "0-3",
		account_indentifier: "11-23"
	},
	IR: {
		chars: 26,
		bban_regexp: "^[0-9]{22}$"
	},
	IS: {
		chars: 26,
		bban_regexp: "^[0-9]{22}$",
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "2-3",
		bank_identifier: "0-1",
		account_indentifier: "8-25"
	},
	IT: {
		chars: 27,
		bban_regexp: "^[A-Z]{1}[0-9]{10}[A-Z0-9]{12}$",
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "6-10",
		bank_identifier: "1-5",
		account_indentifier: "4-27"
	},
	JE: {},
	JM: {},
	JO: {
		chars: 30,
		bban_regexp: "^[A-Z]{4}[0-9]{4}[A-Z0-9]{18}$",
		IBANRegistry: !0,
		branch_indentifier: "4-7",
		bank_identifier: "4-7"
	},
	JP: {},
	KE: {},
	KG: {},
	KH: {},
	KI: {},
	KM: {
		chars: 27,
		bban_regexp: "^[0-9]{23}$"
	},
	KN: {},
	KP: {},
	KR: {},
	KW: {
		chars: 30,
		bban_regexp: "^[A-Z]{4}[A-Z0-9]{22}$",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		account_indentifier: "20-30"
	},
	KY: {},
	KZ: {
		chars: 20,
		bban_regexp: "^[0-9]{3}[A-Z0-9]{13}$",
		IBANRegistry: !0,
		bank_identifier: "0-2",
		account_indentifier: "0-20"
	},
	LA: {},
	LB: {
		chars: 28,
		bban_regexp: "^[0-9]{4}[A-Z0-9]{20}$",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		account_indentifier: "14-28"
	},
	LC: {
		chars: 32,
		bban_regexp: "^[A-Z]{4}[A-Z0-9]{24}$",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		account_indentifier: "8-32"
	},
	LI: {
		chars: 21,
		bban_regexp: "^[0-9]{5}[A-Z0-9]{12}$",
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-4"
	},
	LK: {},
	LR: {},
	LS: {},
	LT: {
		chars: 20,
		bban_regexp: "^[0-9]{16}$",
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-4"
	},
	LU: {
		chars: 20,
		bban_regexp: "^[0-9]{3}[A-Z0-9]{13}$",
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-2"
	},
	LV: {
		chars: 21,
		bban_regexp: "^[A-Z]{4}[A-Z0-9]{13}$",
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-3",
		account_indentifier: "0-21"
	},
	LY: {
		chars: 25,
		bban_regexp: "^[0-9]{21}$",
		IBANRegistry: !0,
		branch_indentifier: "3-5",
		bank_identifier: "0-2",
		account_indentifier: "10-25"
	},
	MA: {
		chars: 28,
		bban_regexp: "^[0-9]{24}$"
	},
	MC: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
		bban_validation_func: k,
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "5-9",
		bank_identifier: "0-4"
	},
	MD: {
		chars: 24,
		bban_regexp: "^[A-Z0-9]{2}[A-Z0-9]{18}$",
		IBANRegistry: !0,
		bank_identifier: "0-1",
		account_indentifier: "6-24"
	},
	ME: {
		chars: 22,
		bban_regexp: "^[0-9]{18}$",
		bban_validation_func: S,
		IBANRegistry: !0,
		bank_identifier: "0-2",
		account_indentifier: "4-22"
	},
	MF: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
		IBANRegistry: !0
	},
	MG: {
		chars: 27,
		bban_regexp: "^[0-9]{23}$"
	},
	MH: {},
	MK: {
		chars: 19,
		bban_regexp: "^[0-9]{3}[A-Z0-9]{10}[0-9]{2}$",
		bban_validation_func: S,
		IBANRegistry: !0,
		bank_identifier: "0-2"
	},
	ML: {
		chars: 28,
		bban_regexp: "^[A-Z0-9]{2}[0-9]{22}$"
	},
	MM: {},
	MN: {
		chars: 20,
		bban_regexp: "^[0-9]{16}$",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		account_indentifier: "8-20"
	},
	MO: {},
	MP: {},
	MQ: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
		IBANRegistry: !0
	},
	MR: {
		chars: 27,
		bban_regexp: "^[0-9]{23}$",
		IBANRegistry: !0,
		branch_indentifier: "5-9",
		bank_identifier: "0-4",
		account_indentifier: "8-26"
	},
	MS: {},
	MT: {
		chars: 31,
		bban_regexp: "^[A-Z]{4}[0-9]{5}[A-Z0-9]{18}$",
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "4-8",
		bank_identifier: "0-3",
		account_indentifier: "15-31"
	},
	MU: {
		chars: 30,
		bban_regexp: "^[A-Z]{4}[0-9]{19}[A-Z]{3}$",
		IBANRegistry: !0,
		branch_indentifier: "6-7",
		bank_identifier: "0-5",
		account_indentifier: "0-30"
	},
	MV: {},
	MW: {},
	MX: {},
	MY: {},
	MZ: {
		chars: 25,
		bban_regexp: "^[0-9]{21}$"
	},
	NA: {},
	NC: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
		IBANRegistry: !0
	},
	NE: {
		chars: 28,
		bban_regexp: "^[A-Z]{2}[0-9]{22}$"
	},
	NF: {},
	NG: {},
	NI: {
		chars: 28,
		bban_regexp: "^[A-Z]{4}[0-9]{20}$",
		bank_identifier: "0-3",
		IBANRegistry: !0,
		account_indentifier: "8-28"
	},
	NL: {
		chars: 18,
		bban_regexp: "^[A-Z]{4}[0-9]{10}$",
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-3",
		account_indentifier: "8-18"
	},
	NO: {
		chars: 15,
		bban_regexp: "^[0-9]{11}$",
		bban_validation_func: y,
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-3",
		account_indentifier: "4-15"
	},
	NP: {},
	NR: {},
	NU: {},
	NZ: {},
	OM: {
		chars: 23,
		bban_regexp: "^[0-9]{3}[A-Z0-9]{16}$",
		IBANRegistry: !0,
		SEPA: !1,
		bank_identifier: "0-2"
	},
	PA: {},
	PE: {},
	PF: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
		IBANRegistry: !0
	},
	PG: {},
	PH: {},
	PK: {
		chars: 24,
		bban_regexp: "^[A-Z0-9]{4}[0-9]{16}$",
		IBANRegistry: !0,
		bank_identifier: "0-3"
	},
	PL: {
		chars: 28,
		bban_validation_func: C,
		bban_regexp: "^[0-9]{24}$",
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "0-7",
		account_indentifier: "2-28"
	},
	PM: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
		IBANRegistry: !0
	},
	PN: {},
	PR: {},
	PS: {
		chars: 29,
		bban_regexp: "^[A-Z0-9]{4}[0-9]{21}$",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		account_indentifier: "17-29"
	},
	PT: {
		chars: 25,
		bban_regexp: "^[0-9]{21}$",
		bban_validation_func: S,
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-3"
	},
	PW: {},
	PY: {},
	QA: {
		chars: 29,
		bban_regexp: "^[A-Z]{4}[A-Z0-9]{21}$",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		account_indentifier: "8-29"
	},
	RE: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
		IBANRegistry: !0
	},
	RO: {
		chars: 24,
		bban_regexp: "^[A-Z]{4}[A-Z0-9]{16}$",
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-3",
		account_indentifier: "0-24"
	},
	RS: {
		chars: 22,
		bban_regexp: "^[0-9]{18}$",
		bban_validation_func: S,
		IBANRegistry: !0,
		bank_identifier: "0-2"
	},
	RU: {
		chars: 33,
		bban_regexp: "^[0-9]{14}[A-Z0-9]{15}$",
		IBANRegistry: !0,
		branch_indentifier: "9-13",
		bank_identifier: "0-8",
		account_indentifier: "13-33"
	},
	RW: {},
	SA: {
		chars: 24,
		bban_regexp: "^[0-9]{2}[A-Z0-9]{18}$",
		IBANRegistry: !0,
		bank_identifier: "0-1",
		account_indentifier: "12-24"
	},
	SB: {},
	SC: {
		chars: 31,
		bban_regexp: "^[A-Z]{4}[0-9]{20}[A-Z]{3}$",
		IBANRegistry: !0,
		branch_indentifier: "6-7",
		bank_identifier: "0-5",
		account_indentifier: "12-28"
	},
	SD: {
		chars: 18,
		bban_regexp: "^[0-9]{14}$",
		IBANRegistry: !0,
		bank_identifier: "0-1",
		account_indentifier: "6-18"
	},
	SE: {
		chars: 24,
		bban_regexp: "^[0-9]{20}$",
		IBANRegistry: !0,
		SEPA: !0,
		bank_identifier: "0-2"
	},
	SG: {},
	SH: {},
	SI: {
		chars: 19,
		bban_regexp: "^[0-9]{15}$",
		bban_validation_func: S,
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "2-4",
		bank_identifier: "0-1",
		account_indentifier: "9-16"
	},
	SJ: {},
	SK: {
		chars: 24,
		bban_regexp: "^[0-9]{20}$",
		bban_validation_func: D,
		IBANRegistry: !0,
		SEPA: !0
	},
	SL: {},
	SM: {
		chars: 27,
		bban_regexp: "^[A-Z]{1}[0-9]{10}[A-Z0-9]{12}$",
		IBANRegistry: !0,
		SEPA: !0,
		branch_indentifier: "6-10"
	},
	SN: {
		chars: 28,
		bban_regexp: "^[A-Z]{2}[0-9]{22}$"
	},
	SO: {
		chars: 23,
		bban_regexp: "^[0-9]{19}$",
		IBANRegistry: !0,
		branch_indentifier: "4-6",
		account_indentifier: "11-23"
	},
	SR: {},
	SS: {},
	ST: {
		chars: 25,
		bban_regexp: "^[0-9]{21}$",
		IBANRegistry: !0,
		branch_indentifier: "4-7"
	},
	SV: {
		chars: 28,
		bban_regexp: "^[A-Z]{4}[0-9]{20}$",
		IBANRegistry: !0,
		account_indentifier: "8-28"
	},
	SX: {},
	SY: {},
	SZ: {},
	TC: {},
	TD: {
		chars: 27,
		bban_regexp: "^[0-9]{23}$"
	},
	TF: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
		IBANRegistry: !0
	},
	TG: {
		chars: 28,
		bban_regexp: "^[A-Z]{2}[0-9]{22}$"
	},
	TH: {},
	TJ: {},
	TK: {},
	TL: {
		chars: 23,
		bban_regexp: "^[0-9]{19}$",
		IBANRegistry: !0,
		account_indentifier: "4-23"
	},
	TM: {},
	TN: {
		chars: 24,
		bban_regexp: "^[0-9]{20}$",
		IBANRegistry: !0,
		branch_indentifier: "2-4",
		account_indentifier: "4-24"
	},
	TO: {},
	TR: {
		chars: 26,
		bban_regexp: "^[0-9]{5}[A-Z0-9]{17}$",
		IBANRegistry: !0
	},
	TT: {},
	TV: {},
	TW: {},
	TZ: {},
	UA: {
		chars: 29,
		bban_regexp: "^[0-9]{6}[A-Z0-9]{19}$",
		IBANRegistry: !0,
		account_indentifier: "15-29"
	},
	UG: {},
	UM: {},
	US: {},
	UY: {},
	UZ: {},
	VA: {
		chars: 22,
		bban_regexp: "^[0-9]{18}",
		IBANRegistry: !0,
		SEPA: !0,
		account_indentifier: "7-22"
	},
	VC: {},
	VE: {},
	VG: {
		chars: 24,
		bban_regexp: "^[A-Z0-9]{4}[0-9]{16}$",
		IBANRegistry: !0,
		account_indentifier: "8-24"
	},
	VI: {},
	VN: {},
	VU: {},
	WF: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
		IBANRegistry: !0
	},
	WS: {},
	XK: {
		chars: 20,
		bban_regexp: "^[0-9]{16}$",
		IBANRegistry: !0,
		branch_indentifier: "2-3",
		account_indentifier: "4-20"
	},
	YE: {
		chars: 30,
		bban_regexp: "[A-Z]{4}[0-9]{4}[0-9A-Z]{18}",
		IBANRegistry: !0,
		bank_identifier: "0-3",
		branch_indentifier: "4-7"
	},
	YT: {
		chars: 27,
		bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
		IBANRegistry: !0
	},
	ZA: {},
	ZM: {},
	ZW: {}
}, j = "Die eingegebene IBAN ist ungültig. Bitte überprüfe die Eingabe.", M = class extends e(r(i)) {
	constructor(...e) {
		super(...e), this.data = { payByBankTransfer: !0 }, this._payByBankTransfer = !0, this._bankAccountOwner = "", this._iban = "", this._ibanTouched = !1, this._bankName = "";
	}
	get _ibanInvalid() {
		return this._ibanTouched && this._iban.trim() !== "" && !u(h(this._iban) ?? this._iban);
	}
	willUpdate(e) {
		e.has("data") && this.data && (this._payByBankTransfer = this.data.payByBankTransfer, this._bankAccountOwner = this.data.bankAccountOwner ?? "", this._iban = this.data.iban ?? "", this._bankName = this.data.bankName ?? "");
	}
	_handleSectionChange() {
		this._payByBankTransfer || (this._bankAccountOwner = "", this._iban = "", this._bankName = ""), this.dispatchEvent(new CustomEvent("change", {
			detail: {
				payByBankTransfer: this._payByBankTransfer,
				bankAccountOwner: this._bankAccountOwner || void 0,
				iban: this._iban || void 0,
				bankName: this._bankName || void 0
			},
			bubbles: !0,
			composed: !0
		}));
	}
	render() {
		return a`
            <section class="w-full">
                <h2 class="mb-4 px-2 text-xl font-semibold">Bankverbindung</h2>

                <div class="flex flex-col gap-4">
                    <div class="flex items-center gap-2 px-2">
                        <ptc-ui-checkbox
                            id="payByBankTransfer"
                            name="payByBankTransfer"
                            .checked=${this._payByBankTransfer}
                            @change=${(e) => {
			e.stopPropagation(), this._payByBankTransfer = e.detail.checked, this._handleSectionChange();
		}}
                        ></ptc-ui-checkbox>
                        <label for="payByBankTransfer" class="text-sm font-medium text-gray-700"
                            >Zahlung per Banküberweisung</label
                        >
                    </div>

                    ${this._payByBankTransfer ? a`
                              <div class="flex gap-4">
                                  <div class="flex-1">
                                      <ptc-ui-text-input
                                          name="bankAccountOwner"
                                          label="Kontoinhaber"
                                          placeholder="Name des Kontoinhabers"
                                          .value=${this._bankAccountOwner}
                                          maxlength="200"
                                          required
                                          @change=${(e) => {
			e.stopPropagation(), this._bankAccountOwner = e.detail.value, this._handleSectionChange();
		}}
                                      ></ptc-ui-text-input>
                                  </div>

                                  <div class="flex-1">
                                      <ptc-ui-text-input
                                          name="iban"
                                          label="IBAN"
                                          placeholder="z.B. DE89370400440532013000"
                                          .value=${this._iban}
                                          required
                                          @input=${(e) => {
			e.stopPropagation(), this._iban = e.detail.value;
		}}
                                          @change=${(e) => {
			e.stopPropagation(), this._iban = e.detail.value, this._handleSectionChange();
		}}
                                          @blur=${(e) => {
			e.stopPropagation(), this._ibanTouched = !0;
		}}
                                      ></ptc-ui-text-input>
                                      ${this._ibanInvalid ? a`<p class="mt-1 text-sm text-red-600">${j}</p>` : o}
                                  </div>
                              </div>

                              <div class="flex gap-4">
                                  <div class="flex-1">
                                      <ptc-ui-text-input
                                          name="bankName"
                                          label="Name der Bank"
                                          placeholder="Name der Bank eingeben"
                                          .value=${this._bankName}
                                          maxlength="200"
                                          @change=${(e) => {
			e.stopPropagation(), this._bankName = e.detail.value, this._handleSectionChange();
		}}
                                      ></ptc-ui-text-input>
                                  </div>
                                  <div class="flex-1"></div>
                              </div>
                          ` : o}
                </div>
            </section>
        `;
	}
};
n([c({ type: Object }), t("design:type", Object)], M.prototype, "data", void 0), n([l(), t("design:type", Object)], M.prototype, "_payByBankTransfer", void 0), n([l(), t("design:type", Object)], M.prototype, "_bankAccountOwner", void 0), n([l(), t("design:type", Object)], M.prototype, "_iban", void 0), n([l(), t("design:type", Object)], M.prototype, "_ibanTouched", void 0), n([l(), t("design:type", Object)], M.prototype, "_bankName", void 0), M = n([s("ptc-ui-employee-questionnaire-bank-details-section")], M);
//#endregion
export { M as t };

//# sourceMappingURL=bank-details-section-3Al1Xzxl.js.map